import { Bot, Calculator, Database, Users, type LucideIcon } from "lucide-react"

type EntityIconKey = "agents" | "personas" | "test-sets" | "metrics"

/**
 * The glyph for each core evaluation entity. Surfaces that label an agent,
 * persona, test set, or metric read it from here instead of picking a lucide
 * icon locally, so the sidebar nav, the command palette that derives from it,
 * and Home's setup cards all draw the same entity the same way.
 */
export const ENTITY_ICONS: Record<EntityIconKey, LucideIcon> = {
  agents: Bot,
  personas: Users,
  "test-sets": Database,
  metrics: Calculator,
}
